import { useMemo, type CSSProperties } from "react";
import { range, rand } from "../utils/random";
import type { EffectProps } from "./types";

export function FloatingBubbles({ count = 35 }: EffectProps = {}) {
  const bubbles = useMemo(
    () =>
      range(count).map(i => {
        const size = rand(14, 56);
        return {
          id: i,
          left: `${rand(0, 100)}vw`,
          size: `${size}px`,
          riseDuration: `${rand(8, 16)}s`,
          delay: `${rand(-16, 0)}s`,
          opacity: rand(0.45, 0.85),
        };
      }),
    [count],
  );

  return (
    <div className="fx-layer" aria-hidden>
      {bubbles.map(b => (
        <span
          key={b.id}
          className="fx-particle fx-bubble"
          style={
            {
              left: b.left,
              top: 0,
              width: b.size,
              height: b.size,
              opacity: b.opacity,
              animationDuration: b.riseDuration,
              animationDelay: b.delay,
            } as CSSProperties
          }
        />
      ))}
    </div>
  );
}
